import { formatColumnName, formatCellValue } from './formatters';

export const exportToCsv = (
  data: any[],
  columns: string[],
  filename: string = 'export',
  columnAliases?: Record<string, string>
) => {
  if (!data || data.length === 0) {
    console.warn('No data to export');
    return;
  }

  // Create CSV header with formatted column names
  const headers = columns.map(col => columnAliases?.[col] || formatColumnName(col));
  const csvHeader = headers.map(header => `"${header}"`).join(',');

  // Create CSV rows
  const csvRows = data.map(row => {
    return columns.map(col => {
      const value = formatCellValue(row[col], col);
      // Escape quotes and wrap in quotes if contains comma, quote, or newline
      if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))) {
        return `"${value.replace(/"/g, '""')}"`;
      }
      return value;
    }).join(',');
  });

  // Combine header and rows
  const csvContent = [csvHeader, ...csvRows].join('\n');

  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  // Generate filename with timestamp
  const timestamp = new Date().toISOString().slice(0, 10);
  const fullFilename = `${filename}_${timestamp}.csv`;
  
  link.setAttribute('href', url);
  link.setAttribute('download', fullFilename);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};